import { EVENT_PLATFORMS, EVENTS_ORG, LoginMethods } from '@pw-tech/web-sdk'

const AUTH_CONFIG = {
  organizationId: process.env.REACT_APP_PP_PW_ORGANIZATION_ID || '',
  apiBaseUrl: process.env.REACT_APP_PP_API_BASE_URL || '',
  loginMethods: [LoginMethods.OTP, LoginMethods.PASSWORD],
  localStorageFallback: true,
  clientId: 'system-admin',
  clientSecret: 'KjPXuAVfC5xbmgreETNMaL7z',
  contextIdentifier: 'TOKEN_CONTEXT_AMBASSADOR',
  loginPageUrl: '/',
  debugMode: true,
  eventConfig: {
    organizationName: EVENTS_ORG.PHYSICS_WALLAH,
    eventPlatforms: [EVENT_PLATFORMS.GA],
    eventsDebugMode: true,
  },
}

export default AUTH_CONFIG